$(function() {

    var tileCalculator = {

        // The default waste to add on in percent
        waste : false,

        // What percentage of waste to use?
        wastePercentage : 10,

        // The tile object
        product : {
            // Width,  in cm
            width      : 0,
            // Length, in cm
            length     : 0,
            // Tiles per pack 
            per_pack   : 0,
            // Price, in GBP
            price      : 0.00,
            // Price per tile
            price_each : "0.00",
            // Coverage per pack (sqm)
            coverage   : "0.00",
            // Price per sqm
            price_sqm  : "0.00",
        },

        // Default product quantity
        qty: 1,

        // Boot
        init: function() {
            
            // Set the tile prices / object
            this.update()

            // Setup some event listeners
            this.listeners()

        },

        // Update the current tile object
        update: function() {

            var $input = $('#tileSize option:selected')

            // The tile object
            this.product = {
                width      : $input.data('width'),
                length     : $input.data('length'),
                per_pack   : $input.data('per-pack'),
                price      : $input.data('price'), 
                price_each : this.priceEach($input.data('price'), $input.data('per-pack')),
            },

            // Get the coverage of the current object
            this.product.coverage = this.sqm(this.qty)

            // Get the coverage of the current object
            this.product.price_sqm = this.pricePerSqm()

            // Feed the dom
            this.dom()

        },

        // Update the DOM elements with new information
        dom : function() {

            // Product : Price per tile
            $('#productPerTile').text(this.product.price_each)
            // Product : Price per sqm
            $('.productPerSqm').text(this.product.price_sqm)
            // Product : Total price
            $('#productPriceTotal').text(this.getFlooredFixed((this.product.price * this.qty), 2))
            // Product : Coverage of sqm
            $('#productMetresSq').val(this.product.coverage)
            // Product : Tiles per pack
            $('#productTilesPerPack').text(this.product.per_pack)
            // Product : Quantity
            $('#productQty').text(this.qty)

        },

        // Attach event listeners
        listeners: function() {

            // The tile size is changed
            $('#tileSize').on('change', this.update.bind(this))

            // The product qty is changed
            $('#productQty').on('keyup change', this.qtyCalc.bind(this))

            // The product sqm is changed
            $('#productMetresSq').on('keyup', this.sqmCalc.bind(this))

            // The product waste is chosen
            $('#productWaste').on('change', this.wasteCalc.bind(this))

        },

        // Calculate the SQM of the tile pack
        // @param qty - the tiles per pack
        sqm: function(qty) {

            var area = (this.product.width * this.product.length)

            // Compute
            var calc = (area * this.product.per_pack / 10000) * qty

            // Square meter per pack
            return this.getFlooredFixed(calc, 2)

        },

        // Calculate the packs required per sqm
        packs: function(sqm) {

            // How many packs to achieve the sqm?
            var packsRequired = 10000 / (this.product.width * this.product.length) * sqm

            // Are we calculating waste?
            if (this.waste) {
                var wastage = (packsRequired / 100) * this.waste
                packsRequired = packsRequired + wastage
            }

            // Compute
            var calc = packsRequired / this.product.per_pack

            // Don't allow less than 1
            if (calc < 1) calc = 1

            // How many packs rounding UP to nearest integer
            return Math.ceil(calc)

        },

        // Calculate the price based on quantity
        qtyCalc: function() {

            if (this.waste) {
                console.info('Calculating QTY -> SQM with ' + this.wastePercentage + '% waste')
            } else {
                console.info('Calculating QTY -> SQM with 0% waste')
            }

            // How many packs?
            this.qty = parseInt($('#productQty').val())

            // Sanity check it
            if (isNaN(this.qty)) {
                return false;
            }

            // Don't allow less than 1
            if (this.qty < 1) {
                this.qty = 1;
                $('#productQty').val(1)
            }
            
            // What sqm does the quantity cover?
            var sqm = this.sqm(this.qty)
            
            // Update the coverage
            $('#productMetresSq').val(sqm)
            
            // Update the price
            this.updatePrice()

        },

        // Calculate the product packs required per sqm
        sqmCalc: function() {

            // Get the sqm
            var sqm = parseFloat($('#productMetresSq').val())
            
            // Sanity check it
            if (isNaN(sqm)) {
                return false
            }

            if (this.waste) {
                console.info('Calculating SQM -> QTY ' + this.wastePercentage + '% waste')
            } else {
                console.info('Calculating SQM -> QTY with 0% waste')
            }

            // How many packs rounding up to nearest integer
            tilesRequired = this.packs(sqm)

            // Update the quantity
            this.qty = tilesRequired;

            // Set the quantity
            $('#productQty').val(tilesRequired)

            // Update the price
            this.updatePrice()
            
        },

        // Calculate the per tile cost
        priceEach: function(price, perPack) {

            return this.getFlooredFixed((price / perPack), 2)

        },

        // Calculate the per tile cost
        pricePerSqm: function() {

            var sqm = 10000 / (this.product.width * this.product.length) * 1
            return this.getFlooredFixed((sqm * this.product.price_each), 2)

        },

        // Recalculate the waste if toggled
        wasteCalc: function(event) {

            // Get the checkbox state
            var checkbox = event.target

            // Allow for waste
            if (checkbox.checked) {
                this.waste = this.wastePercentage
            // Remove 
            } else {
                this.waste = false
            }

            this.sqmCalc()

        },

        // Format a number with 2 decimals but don't round up
        getFlooredFixed: function (v, d) {
            return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
        },
        
        // Update the product price
        updatePrice: function(price) {

            // Update the price
            var price = this.getFlooredFixed((this.product.price * this.qty), 2)
            console.log(price)
            price = price.toLocaleString('en')
            $('#productPriceTotal').text(price)

        }

    }
  
    // Boot the calculator
    tileCalculator.init()

});